import { render, staticRenderFns } from "./infotext.vue?vue&type=template&id=d022d8bc&"
import script from "./infotext.vue?vue&type=script&lang=js&"
export * from "./infotext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports